import React, { ReactNode } from "react";
import { Box, Typography } from "@material-ui/core";

export const DEFAULT_BLANK_VALUE = "-";

interface FieldProps {
  label: string;
  value?: ReactNode | string | null;
  hideEmpty?: boolean;
  fullWidth?: boolean;
  "data-testid"?: string;
}

/**
 *
 * @param label - Label of field
 * @param value - Contents of field
 * @param dataTestId - Testing only
 * @param hideEmpty - default is to always show this field, enable this to hide when value is empty
 * @param fullWidth - default is half of the dialog, enable this for full width of dialog
 */
export const Field: React.FC<FieldProps> = ({
  label,
  value,
  "data-testid": dataTestId,
  hideEmpty,
  fullWidth,
}) => {
  if (hideEmpty && !value) return null;
  return (
    <Box maxWidth={fullWidth ? 536 : 260} width={fullWidth ? 1 : 0.49} mb={2.5}>
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
      <Typography data-testid={dataTestId} variant="subtitle1">
        {value || DEFAULT_BLANK_VALUE}
      </Typography>
    </Box>
  );
};
